import {ItemAssignment, SignatureModel} from '../../types/api';
import {
    apiDelete,
    createListResponse,
    customList,
    get,
    list,
    ListResponse,
    mergeParamsAndDefaultOrder,
    post,
    PostFn,
    put,
    RequestOptions,
    SortOrder,
} from './CRUD';
import {RecursivePartial} from '../../types/list';
import {clearAssociationIds} from './clearAssociation';
import {AxiosRequestConfig} from 'axios';
import Api from '../../lib/apiClient';
import {clearCachesByTag} from '../../lib/cache';
import {EntityName} from './entities.ts';
export const profileSignatureCacheTag = 'profile-signatures';

export const listSignatureModels = (options?: RequestOptions) => {
    return list<SignatureModel>(EntityName.SignatureModel, {
        ...options,
        params: mergeParamsAndDefaultOrder(options?.params, {
            title: SortOrder.Asc,
        }),
    });
};

export const listProfileSignatureModels = async (
    profileId: string,
): Promise<ListResponse<SignatureModel>> => {
    return createListResponse(
        await customList<any>(`${EntityName.Profile}/${profileId}/signatures`, [
            profileSignatureCacheTag,
        ]),
    );
};

export const getSignatureModel = (id: string) =>
    get<SignatureModel>(EntityName.SignatureModel, id);

export const getSignatureModelAssignment = async (
    id: string,
    options: AxiosRequestConfig<ItemAssignment> = {},
) => {
    return (
        await Api.get(`/${EntityName.SignatureModel}/${id}/assignment`, options)
    ).data as ItemAssignment;
};

export const putSignatureModelAssignment = async (
    id: string,
    data: ItemAssignment,
) => {
    clearCachesByTag(profileSignatureCacheTag);

    return (
        await Api.put(`/${EntityName.SignatureModel}/${id}/assignment`, data)
    ).data as ItemAssignment;
};

export const postSignatureModel: PostFn<
    SignatureModel,
    RecursivePartial<SignatureModel>
> = data => {
    clearCachesByTag(profileSignatureCacheTag);
    clearCachesByTag(EntityName.Profile);

    return post(EntityName.SignatureModel, data);
};

export const putSignatureModel = async (
    id: string,
    data: RecursivePartial<SignatureModel | ItemAssignment>,
) => {
    const r = await put<SignatureModel>(
        EntityName.SignatureModel,
        id,
        clearAssociationIds(data),
    );
    clearCachesByTag(EntityName.Profile);
    clearCachesByTag(profileSignatureCacheTag);

    return r;
};

export const deleteSignatureModel = (id: string) => {
    clearCachesByTag(profileSignatureCacheTag);
    clearCachesByTag(EntityName.Profile);

    return apiDelete<SignatureModel>(EntityName.SignatureModel, id);
};
